/**
 * Текст ошибки (например из WS или detail) без HTTP-обёртки.
 */
export function matchesInsufficientBalanceText(text) {
    const t = text.toLowerCase();
    if (!t.trim()) {
        return false;
    }
    return (/недостаточно\s+(средств|кредит|баланс)/i.test(t) ||
        /insufficient\s+(funds|balance|credits)/i.test(t) ||
        /not\s+enough\s+(credits|balance|funds)/i.test(t) ||
        /мало\s+кредит/i.test(t) ||
        /не\s+хватает\s+(средств|кредит)/i.test(t) ||
        /low\s+balance/i.test(t) ||
        /\b(insufficient_credits|insufficient_balance|not_enough_credits|low_balance)\b/i.test(t));
}
function detailToString(detail) {
    if (typeof detail === "string") {
        return detail;
    }
    if (Array.isArray(detail)) {
        return detail
            .map((item) => {
            if (typeof item === "string")
                return item;
            if (item && typeof item === "object" && "msg" in item) {
                return String(item.msg ?? "");
            }
            return JSON.stringify(item);
        })
            .join(" ");
    }
    if (detail && typeof detail === "object") {
        return JSON.stringify(detail);
    }
    return "";
}
/**
 * Определяет ответ API о нехватке кредитов / баланса (эвристика + 402).
 */
export function isInsufficientBalanceError(error) {
    const err = error;
    const status = err.response?.status;
    if (status === 402) {
        return true;
    }
    const data = err.response?.data;
    const text = [
        detailToString(data?.detail),
        typeof data?.message === "string" ? data.message : "",
    ]
        .join(" ")
        .toLowerCase();
    return matchesInsufficientBalanceText(text);
}
